<div
  class="words-container word-list"
  cdkDropList
  #wordList="cdkDropList"
  cdkDropListOrientation="mixed"
  [cdkDropListData]="strings"
  [cdkDropListConnectedTo]="[answerList]"
  (cdkDropListDropped)="drop($event)"
>
  @for (string of strings; track string) {
    <div class="word" cdkDrag (click)="handleStringClick(string)">{{ string }}</div>
  }
</div>

<div class="word-container">
  <div class="answer-line 1"></div>
  <div class="answer-line 2"></div>
  <div class="answer-line 3"></div>
  <div class="answer-line 4"></div>
  <div class="answer-line 5"></div>
  <div class="answer-line 6"></div>
  <div class="answer-line 7"></div>
  <div class="answer-line 8"></div>
  <div class="answer-line 9"></div>
  <div
    class="answer-word-list"
    cdkDropList
    #answerList="cdkDropList"
    cdkDropListOrientation="mixed"
    [cdkDropListData]="answer"
    [cdkDropListConnectedTo]="[wordList]"
    (cdkDropListDropped)="drop($event)"
  >
    @for (answer of answer; track answer) {
      <div class="word" cdkDrag (click)="handleAnswerClick(answer)">{{ answer }}</div>
    }
  </div>
</div>
